import { observable, action, computed, autorun } from 'mobx'
import _toArray from 'lodash/toArray'
import { NotificationSettingsData } from 'components/Settings/AlertType/AlertType'
import accountStore from 'config/store/AccountStore'

export class NotificationSettingsStore {
  @observable settingsData: Map<string, NotificationSettingsData> = new Map()
  @observable updatedSettings: Map<string, NotificationSettingsData> = new Map()
  @observable loading: boolean = false
  @observable error: string | null = null
  @observable accountIds: string[] = []
  @observable selectedAccount: string | null = null
  @observable pendingSelectedAccount: string | null = null
  @observable applySelectedAccount: boolean = false
  @observable isUpdating: boolean = false
  @observable shouldRefetch: boolean = false
  @observable OpenReceiversDialog: boolean = false

  constructor() {
    autorun(() => {
      if (this.selectedAccount) {
        this.clear()
        this.shouldRefetch = true
      } else {
        this.pendingSelectedAccount = this.accounts.length > 0 ? this.accounts[0].id : null
        this.selectedAccount = this.accounts.length > 0 ? this.accounts[0].id : null
      }
  })
  }

  @action
  setSelectedAccount(accountId: string | null) {
    this.selectedAccount = accountId
  }

  @action
  setPendingSelectedAccount(accountId: string | null) {
    this.pendingSelectedAccount = accountId
  }

  @action
  setApplySelectedAccount(value: boolean) {
    this.applySelectedAccount = value
    this.selectedAccount = this.pendingSelectedAccount
  }

  @action
  setShouldRefetch(value: boolean) {
    this.shouldRefetch = value
  }

  @action
  setSettingsData(key: string, value: NotificationSettingsData) {
    this.settingsData.set(key, value)
    this.updatedSettings.set(key, value)
    this.isUpdating = true
  }

  @action
  initializeSettingsData(settings: Map<string, NotificationSettingsData>) {
    this.settingsData = settings
    this.isUpdating = false
  }

  @action
  setIsUpdating(value: boolean) {
    this.isUpdating = value
  }

  @action
  clear() {
    this.settingsData = new Map()
    this.updatedSettings = new Map()
    this.isUpdating = false
  }

  @computed 
  get accounts() {
    const { accounts } = accountStore
    return accounts
      .map(
        (account: {
          subAccountIds?: string[]
          id: string
          name: string
          subAccounts: any
        }) => {
          if (account.subAccountIds && account.subAccountIds.length > 0) {
            return _toArray(account.subAccounts).map((subAccount: any) => subAccount)
          }
          return account
        }
      )
      .flat()
  }
}

export default new NotificationSettingsStore()
